import { REQUESTS_ABSENCE_EDIT_PATH } from "@/modules/requests/pages/requests-absence-form";
import { generatePath, Navigate } from "react-router-dom";

export function OpenAbsenceRequest() {
  return (
    <Navigate
      to={generatePath(REQUESTS_ABSENCE_EDIT_PATH, {
        id: new URL(window.location.href).searchParams.get("id"),
      })}
    />
  );
}
